import React, { useState } from 'react';
import s from './Checkout.module.scss';
import Select from 'react-select';
import useGetSalonsAllowedCountries from 'sdk/hooks/useGetSalonsAllowedCountries';
import Button from 'components/shared/Button';
import clsx from 'clsx';
import { ReactComponent as EditingCircle } from 'images/new-icons/editing-circle.svg';
import useIsAuth from 'sdk/hooks/useIsAuth';

const AddNewAddressForm = ({ addAddress, refetch, hide }) => {
  const [newAddress, setNewAddress] = useState({
    city: '',
    street: '',
    apartment: '',
    zip_code: '',
    country: '',
  });
  const { data: isAuthData } = useIsAuth();

  const { data: salonsAllowerCountries } = useGetSalonsAllowedCountries();
  const userId = isAuthData?.user?.id;

  const countries = salonsAllowerCountries?.map(item => {
    return {
      value: item.id,
      label: item.country_name,
    };
  });

  const handleChangeField = (field, e) => {
    setNewAddress({
      ...newAddress,
      [field]: e.target.value,
    });
  };

  const handleChangeCountry = e => {
    setNewAddress({
      ...newAddress,
      country: e.label,
    });
  };

  const onSubmit = () => {
    addAddress(
      { newAddress, userId },
      {
        onError: error => {
          console.error('Failed to update gender:', error);
        },
        onSuccess: () => {
          refetch();
          hide(false);
        },
      },
    );
  };

  return (
    <>
      <div className={clsx(s.address_card, s.selected)}>
        {/* <div className={clsx(s.card, s.card_border)}>

                    <div className={s.card_editing}>
                        <EditingCircle />
                    </div>

                    <div style={{ width: '100%' }}>
                        <div className={s.card_header}>
                            <div className={s.card_header_title}>{newAddress.street}</div>
                        </div>
                        <div className={s.card_body}>
                            <div className={s.card_body_title}>
                                {`${newAddress.country}. ${newAddress.city}, ${newAddress.state}, ${newAddress.street} ${newAddress.apartment}, ${newAddress.zip_code}`}
                            </div>
                            <div className={s.card_body_number}>{isAuthData?.user?.phone || 'No user phone'}</div>
                        </div>
                    </div>
                </div> */}
      </div>
      <div className={s.editing}>
        <input
          className={s.editing_text_field}
          placeholder="City"
          onChange={e => handleChangeField('city', e)}
        />
        <input
          className={s.editing_text_field}
          placeholder="Street"
          onChange={e => handleChangeField('street', e)}
        />
        <input
          className={s.editing_text_field}
          placeholder="Apartment,
                        Suit, Unit (Optional)"
          onChange={e => handleChangeField('apartment', e)}
        />
        <input
          className={s.editing_text_field}
          placeholder="Postal Zip
                        Code"
          onChange={e => handleChangeField('zip_code', e)}
        />
        <Select
          options={countries}
          isClearable
          placeholder="Country/Region"
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              border: '1px solid #00000033',
              borderRadius: '12px',
              padding: '4px 8px',
              fontSize: '14px',
            }),
          }}
          onChange={e => handleChangeCountry(e)}
        />
        <div className={s.editing_check}>
          <input type="checkbox" />
          <div className={s.editing_check_text}>
            Fullfill online orders from this location. Inventory at this location is available for
            sale online.
          </div>
        </div>
        <Button
          wide
          darkGreen
          onClick={onSubmit}
          disabled={
            !newAddress?.city ||
            !newAddress?.street ||
            !newAddress?.zip_code ||
            !newAddress?.country
          }
        >
          Save
        </Button>
        <Button wide darkGreen onClick={() => hide(false)}>
          Close
        </Button>
      </div>
    </>
  );
};

export default AddNewAddressForm;
